module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3n1r2n-8e3e437774f7c59988717aaa189e33d1.svg";